import Swal from "sweetalert2";
import { showAlert } from "helper";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { CollectionCategoryEnum } from "Enums";
import React, { useEffect, useState } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import FormField from '@/shared/components/form/FormField';
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const validate = (values) => {
    const errors = {};
    if (!values.wms_endpoint && !values.wmts_endpoint) {
        errors.wms_endpoint = 'Both WMTS and WMS endpoints cannot be empty.';
        errors.wmts_endpoint = 'Both WMTS and WMS endpoints cannot be empty.';
    }
    if (values.wms_endpoint && !values.wms_version) 
        errors.wms_version = 'WMS version field shouldn’t be empty';

    return errors;
};

const required = value => (value !== undefined ? undefined : 'Required')

const CreateWebServiceAsset = () => {
    const [missions, setMissions] = useState();

    let collection_info = {
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json"
        ],
        "title": "{Constellation} {CollectionID}",
        "description": "HD aerial imagery collection of Canada. Maintained by FastMap",
        "license": "proprietary",
        "summaries": {
            "datetime": {},
            "platform": [],
            "constellation": [],
            "instruments": [],
            "view:off_nadir": {
                "minimum": 0,
                "maximum": 0
            },
            "view:sun_elevation": {
                "minimum": 0,
                "maximum": 0
            },
            "gsd": {
                "minimum": 0,
                "maximum": 0
            },
            "proj:epsg": [],
            "eo:cloud_cover": {
                "minimum": 0,
                "maximum": 0
            },
            "eo:bands": [
                {
                    "name": "band1",
                    "common_name": "red",
                    "center_wavelength": 625,
                    "full_width_half_max": 700
                },
                {
                    "name": "band2",
                    "common_name": "green",
                    "center_wavelength": 500,
                    "full_width_half_max": 565
                },
                {
                    "name": "band3",
                    "common_name": "blue",
                    "center_wavelength": 450,
                    "full_width_half_max": 485
                },
                {
                    "name": "band4",
                    "common_name": "alpha"
                }
            ]
        },
        "keywords": [
            "platform:manned",
            "platform:unmanned"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "description": "Spatial data library managed by FastMap.",
                "url": "https://fastmap.ai"
            }
        ]
    };

    let item_info = {
        "stac_version": "1.0.0",
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json",
            "https://stac-extensions.github.io/processing/v1.0.0/schema.json",
            "https://stac-extensions.github.io/card4l/v1.0.0/optical/schema.json",
            "https://stac-extensions.github.io/web-map-links/v1.2.0/schema.json"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "description": "Add company description here",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "url": "https://fastmap.ai"
            },
            {
                "name": "Licnesee Holder",
                "description": "Add licensee description here",
                "roles": [
                    "licensee"
                ],
                "url": "https://"
            }
        ]
    }

    let item_properties = {
        "description": "{platform} {constellation} {collectionID} captured by {Producer} and licensed by {Licensor}",
        "created": "2024-05-21T20:17:57.150260",
        "updated": "2024-05-21T20:17:57.150260",
        "constellation": "aerial",
        "eo_bands": 4,
        "eo_no_data": "alpha",
        "prj_centroid": [
            -100.0582134139518,
            51.158650916715736
        ],
        "unit": "meter",
        "compression": "deflate",
        "data_type": "uint8",
        "file_data_type": "tiff",
        "file_bits_per_sample": 8,
        "geometric_accuracy_description": "geometric accuracy * GSD"
    }

    const submit = (values) => {
        let webServiceAsset = { ...values };
        webServiceAsset.mission_id = webServiceAsset.mission_id.value;
        webServiceAsset.derived_from = webServiceAsset.derived_from.value;
        webServiceAsset.elevation_model = webServiceAsset.elevation_model.value;
        webServiceAsset.processing_level = webServiceAsset.processing_level.value;
        webServiceAsset.processing_software = webServiceAsset.processing_software.value;
        webServiceAsset.processing_facility = webServiceAsset.processing_facility.value;
        webServiceAsset.processing_lineage = webServiceAsset.processing_lineage.value;
        webServiceAsset.preferred_service = webServiceAsset.preferred_service.value;
        webServiceAsset.platform = webServiceAsset.platform.value;
        webServiceAsset.wms_version = webServiceAsset.wms_version?.value;
        webServiceAsset.collection_info = JSON.parse(webServiceAsset.collection_info);
        webServiceAsset.item_info = JSON.parse(webServiceAsset.item_info);
        webServiceAsset.item_properties = JSON.parse(webServiceAsset.item_properties);

        Swal.fire({
            title: 'Warning!',
            text: `This will save a web-service asset in your assets table in database. Are you sure you want to continue?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.createWebServiceAsset(webServiceAsset).then(() => {
                    showAlert('success', `Web-service Asset is saved.`);
                }).catch((error) => {
                    showAlert('error', `Error in adding the web-service asset. ${error.response.data.detail}`);
                })
            }
        });
    }

    const GetMissions = () => {
        AdminInterface.instance.getMissions().then((response) => {
            let missionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.web_service).map(function (mission) {
                return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
            });

            setMissions(missionsList);
        }).catch(() => {
            showAlert('error', 'Error in getting missions.')
        });
    }

    useEffect(() => {
        GetMissions();
    }, []);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Create Web-Service Asset</CardTitle>
                        <CardSubhead>This reads information in the capabilities URL of TMS/WMS/WMTS web-service you provided and saves them in the assets table in your database.</CardSubhead>
                    </CardTitleWrap>
                    {missions && <Form onSubmit={submit} validate={validate} initialValues={{
                        processing_level: { value: 'L1', label: 'L1' },
                        processing_lineage: { value: 'S1', label: 'S1' },
                        processing_facility: { value: 'Local', label: 'Local' },
                        processing_software: { value: "Pix4D", label: 'Pix4D' },
                        derived_from: { value: 'Frame', label: 'Frame' },
                        elevation_model: { value: undefined, label: 'None' },
                        platform: { value: 'manned', label: 'Manned' },
                        sensor_calibration: '2020Q2',
                        geometric_accuracy: 1,
                        eo_cloud_cover: 0,
                        eo_cloud_shadow: 0,
                        view_off_nadir: 0,
                        view_sun_elevation: 36,
                        collection_info: JSON.stringify(collection_info, undefined, 4),
                        item_info: JSON.stringify(item_info, undefined, 4),
                        item_properties: JSON.stringify(item_properties, undefined, 4)
                    }} >
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="mission_id" component={renderSelectField} options={missions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>TMS Endpoint</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="tms_endpoint" component={FormField} type="text" placeholder="TMS Endpoint" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>WMTS Endpoint</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="wmts_endpoint" component={FormField} type="text" placeholder="WMTS GetCapabilities Endpoint" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>WMS Endpoint</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="wms_endpoint" component={FormField} type="text" placeholder="WMS GetCapabilities Endpoint" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>WMS Version</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="wms_version" component={renderSelectField}
                                            options={[
                                                { value: '1.0.0', label: '1.0.0' },
                                                { value: '1.1.0', label: '1.1.0' },
                                                { value: '1.1.1', label: '1.1.1' },
                                                { value: '1.3.0', label: '1.3.0' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Preferred Service</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="preferred_service" component={renderSelectField} validate={required}
                                            options={[
                                                { value: 'wms', label: 'WMS' },
                                                { value: 'wmts', label: 'WMTS' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sensor Calibration</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="sensor_calibration" component={FormField} type="text" placeholder="Sensor Calibration" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Level</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_level" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'Unknown' },
                                                { value: 'RAW', label: 'RAW' },
                                                { value: 'L0', label: 'L0' },
                                                { value: 'L1', label: 'L1' },
                                                { value: 'L2', label: 'L2' },
                                                { value: 'L3', label: 'L3' },
                                                { value: 'L4', label: 'L4' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Lineage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_lineage" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'Unknown' },
                                                { value: 'S1', label: 'S1' },
                                                { value: 'S2', label: 'S2' },
                                                { value: 'S3', label: 'S3' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Facility</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_facility" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'Unknown' },
                                                { value: 'Local', label: 'Local' },
                                                { value: 'Cloud', label: 'Cloud' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Software</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_software" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'Unknown' },
                                                { value: "CaptureOne", label: 'CaptureOne' },
                                                { value: "MatchAT", label: 'MatchAT' },
                                                { value: "OrthoMaster", label: 'OrthoMaster' },
                                                { value: "OrthoVista", label: 'OrthoVista' },
                                                { value: "Pix4D", label: 'Pix4D' },
                                                { value: "Agisoft", label: 'Agisoft' },
                                                { value: "FastMap Cloud", label: 'FastMap Cloud' },
                                                { value: "Proprietary", label: 'Proprietary' }
                                            ]} />

                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Derived From</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="derived_from" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'Unknown' },
                                                { value: 'Frame', label: 'Frame' },
                                                { value: 'Terrain', label: 'Terrain' },
                                                { value: 'Point Cloud', label: 'Point Cloud' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Elevation Model</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="elevation_model" component={renderSelectField}
                                            options={[
                                                { value: null, label: 'None' },
                                                { value: 'SRTM90', label: 'SRTM90' },
                                                { value: 'SRTM30', label: 'SRTM30' },
                                                { value: 'DEM Terrain Item', label: 'DEM Terrain Item' },
                                                { value: 'DSM Terrain Item', label: 'DSM Terrain Item' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="geometric_accuracy" component={FormField} type="number" placeholder="Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Platform</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="platform" component={renderSelectField}
                                            options={[
                                                { value: 'manned', label: 'Manned' },
                                                { value: 'unmanned', label: 'Unmanned' },
                                                { value: 'CityScan', label: 'CityScan' },
                                                { value: 'StreetScan', label: 'StreetScan' },
                                                { value: 'SiteScan', label: 'SiteScan' },
                                                { value: 'Satellite', label: 'Satellite' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Ground Sampling Distance (GSD)</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_gsd" component={FormField} type="number" decimalScale="1" placeholder="Cloud Cover" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Cover</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_cover" component={FormField} type="number" placeholder="Cloud Cover" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Shadow</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_shadow" component={FormField} type="number" placeholder="Cloud Shadow" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Off Nadir</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_off_nadir" component={FormField} type="number" placeholder="Off Nadir" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sun Elevation</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_sun_elevation" component={FormField} type="number" placeholder="Sun Elevation" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Collection Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="collection_info" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_info" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Properties</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_properties" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                    <Button variant="secondary" type="button" onClick={form.reset}>
                                        Cancel
                                    </Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

export default CreateWebServiceAsset;
